import {
  provideSoftAppsModule,
  withSoftAppsModuleNavItem,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { default as en } from '../i18n/en.json';
import { provideSalesGlobals } from './sales.globals';
import { salesRoutes } from './sales.routes';
import {
  SalesModuleConfig,
  SOFTLINE_MODULE_DOCUMENT_QUERY,
  SOFTLINE_MODULE_SALES,
  SOFTLINE_PERMISSION_WWS_SALES,
} from './sales.shared';

export const provideSalesModule = (config?: SalesModuleConfig) => {
  return [
    ...provideSalesGlobals(config),
    provideSoftAppsModule(
      {
        name: SOFTLINE_MODULE_SALES,
        title: '#SALES.TITLE',
        icon: 'fa-regular fa-piggy-bank',
        route: '/sales',
        permission: SOFTLINE_PERMISSION_WWS_SALES,
        group: getModuleGroupByName('Verkauf'),
      },
      withSoftAppsModuleRoutes({ app: salesRoutes }),
      withSoftAppsModuleTranslation({ de, en }),
      withSoftAppsModuleNavItem([
        {
          name: 'sales-overview',
          title: '#SALES.OVERVIEW_PAGE_TITLE',
          icon: 'fa-regular fa-house',
          routerLink: ['/sales/overview'],
          entry: true,
        },
        {
          name: 'sales-document-create',
          title: 'Belegerfassung',
          icon: 'fa-regular fa-file-invoice',
          routerLink: ['/sales/document/create'],
        },
        {
          name: 'sales-query',
          title: '#DOCUMENT_QUERY.TITLE',
          icon: 'fa-regular fa-file-magnifying-glass',
          routerLink: ['/sales/query'],
          subsetRouterLink: ['/sales/query'],
        },
        {
          name: 'sales-config',
          title: '#SALES.CONFIG.TITLE',
          icon: 'fa-regular fa-gear',
          routerLink: ['/sales/config'],
        },
      ])
    ),
    provideSoftAppsModule(
      {
        name: SOFTLINE_MODULE_DOCUMENT_QUERY,
        title: '#DOCUMENT_QUERY.TITLE',
        icon: 'fa-regular fa-file-magnifying-glass',
        route: '/sales/query',
        permission: SOFTLINE_PERMISSION_WWS_SALES,
        group: getModuleGroupByName('Verkauf'),
      },
      withSoftAppsModuleRoutes({ app: salesRoutes }),
      withSoftAppsModuleTranslation({ de, en })
    ),
  ];
};
